import { OpenClassRegistration, OpenClassSession } from '../types/OpenClass';

export type SessionOutcome = {
  certificatesSent: number;
  failed: number;
  notPresent: number;
  passed: number;
  present: number;
  registered: number;
};

const emptyOutcome = (): SessionOutcome => ({
  certificatesSent: 0,
  failed: 0,
  notPresent: 0,
  passed: 0,
  present: 0,
  registered: 0,
});

export const sessionOutcomesBySession = (
  registrations: OpenClassRegistration[],
): Map<OpenClassSession['id'], SessionOutcome> => {
  const outcomes = new Map<OpenClassSession['id'], SessionOutcome>();

  registrations.forEach((registration) =>
    (registration.sessionAttendances ?? []).forEach((attendance) => {
      const outcome = outcomes.get(attendance.sessionId) ?? emptyOutcome();
      outcome.registered += 1;
      if (attendance.attendanceStatus === 'present') outcome.present += 1;
      if (attendance.attendanceStatus === 'not_present')
        outcome.notPresent += 1;
      if (attendance.result === 'passed') {
        outcome.passed += 1;
        if (registration.certificateSentAt) outcome.certificatesSent += 1;
      }
      if (attendance.result === 'failed') outcome.failed += 1;
      outcomes.set(attendance.sessionId, outcome);
    }),
  );

  return outcomes;
};
